import React from 'react';
import { useNavigate } from 'react-router-dom';
import app from '../../../images/cards/banner.png';

export const Advertisement = () => {
  const handleClick = () => {
    window.open('https://marketingagency.vn/', '_blank'); 
  };
  return (
    <div className="relative w-full md:w-[363px] cursor-pointer" onClick={handleClick}>
      <img className="h-auto w-full  aspect-[363/488]" src={app} alt="app" />
    </div>
  );
};
